export default function (Component) {
      var styles = require("!css-loader!postcss-loader!@/styles.css");
      Component.options.props.styles.default = styles.toString();
        Component.options.__styles = styles.toString();
      }